import capitalize from 'lodash/capitalize';

const PREPOSICOES = ['as', 'com', 'da', 'das', 'de', 'do', 'dos', 'e', 'ou', 'y'];
const TERMOS_PRESERVADOS = ['cpf', 'ies', 'enem'];
const PREPOSICOES_COM_APOSTROFO = ['d', 'dell', 'l', 'all'];

export const formatarTermo = (termo: string): string => {
  if (!termo) {
    return '';
  }

  const termoMinusculo = termo.toLowerCase();

  if (TERMOS_PRESERVADOS.includes(termoMinusculo)) {
    return termo;
  }

  if (PREPOSICOES.includes(termoMinusculo)) {
    return termoMinusculo;
  }

  if (termo.includes("'")) {
    const partes = termo.split("'");
    const primeiraParte = PREPOSICOES_COM_APOSTROFO.includes(partes[0].toLowerCase())
      ? partes[0].toLowerCase()
      : capitalize(partes[0]);
    const segundaParte = partes[1].charAt(0).toUpperCase() + partes[1].slice(1).toLowerCase();

    return primeiraParte + "'" + segundaParte;
  }
  return capitalize(termo);
};

export const formatarNome = (nome?: string): string => {
  if (!nome) {
    return '';
  }

  return nome
    .trim()
    .split(' ')
    .filter((termo) => termo.length > 0)
    .map(formatarTermo)
    .join(' ');
};
